import { getConfig } from '@/config';

export const useUla = () => {
  const sendMessageToUla = (message: string): void => {
    const iframe = document.querySelector('#ulaIframe') as HTMLIFrameElement;
    iframe?.contentWindow?.postMessage(message, getConfig().ULA_URL);
  };

  const loadUserInfo = (): void => {
    sendMessageToUla('getUserInfo');
  };

  const logout = (): Promise<void> => {
    const abortController = new AbortController();
    sendMessageToUla('logout');
    return new Promise((resolve) => {
      globalThis.addEventListener(
        'message',
        (e) => {
          if (e.origin === getConfig().ULA_URL && e.data.name === 'ula-logout') {
            console.log('>>> ULA logout completed');
            abortController.abort();
            resolve();
          }
        },
        { signal: abortController.signal },
      );
    });
  };

  const getIdToken = (forceRefresh = false): Promise<string | null> => {
    // Race: the first postMessage may arrive before the ULA iframe listener is ready (e.g. page opened from an e-mail).
    const GET_ID_TOKEN_RETRY_INTERVAL_MS = 300;
    // Deadline: resolve null rather than hang if the ULA iframe never replies.
    const GET_ID_TOKEN_TIMEOUT_MS = 5000;

    const abortController = new AbortController();
    const message = forceRefresh ? 'getIdTokenForceRefresh' : 'getIdToken';

    return new Promise((resolve) => {
      const cleanup = () => {
        clearInterval(retryInterval);
        clearTimeout(deadline);
        abortController.abort();
      };

      globalThis.addEventListener(
        'message',
        (e) => {
          if (e.origin === getConfig().ULA_URL && e.data.name === 'ula-id-token') {
            cleanup();
            resolve(e.data.idToken ?? null);
          }
        },
        { signal: abortController.signal },
      );

      sendMessageToUla(message);
      const retryInterval = setInterval(() => sendMessageToUla(message), GET_ID_TOKEN_RETRY_INTERVAL_MS);

      const deadline = setTimeout(() => {
        cleanup();
        resolve(null);
      }, GET_ID_TOKEN_TIMEOUT_MS);
    });
  };

  return {
    getIdToken,
    loadUserInfo,
    logout,
  };
};
